import React from 'react'
import { Navbar, Container, Col, Stack, Nav } from 'react-bootstrap'

function Footer(props) {
    return (
        <Navbar bg={props.home ? "primary" : "dark"} variant={props.home ? "dark" : "light"} className={!props.home && 'mt-5'}>
            <Container className='justify-content-center'>
                <Col md={3}>
                    <Stack className='text-center'>
                        <Navbar.Brand>FratRank</Navbar.Brand>
                        <Navbar.Text>
                            <a href='https://github.com/awest010/FratRank'>GitHub Repository</a>
                        </Navbar.Text>
                    </Stack>
                </Col>
                <Col md={3} className='pt-3'>
                    <Navbar.Text >
                        <h6>Created By</h6>
                        <ul>
                            <li>Alex West</li>
                            <li>Alyssa Tadeo</li>
                            <li>Edwin Yu</li>
                            <li>Eric Zhou</li>
                            <li>Frank Wercinski</li>
                        </ul>
                    </Navbar.Text>
                    {/* <Nav.Link href="/addFrat" >Add Frat</Nav.Link> */}
                </Col>
            </Container>
        </Navbar>
    );
}

export { Footer }